import type { PurposeConsents, VendorConsents, VendorsList } from "../analytics/cmp/types";
import { AppEvent } from ".";

type ConsentNotShowedDetail = {
  type: "consentNotShowed";
  vendorsList: VendorsList;
  vendorConsents: VendorConsents;
  purposeConsents: PurposeConsents;
};

export class ConsentNotShowedEvent extends AppEvent<ConsentNotShowedDetail> {
  constructor({ vendorsList, vendorConsents, purposeConsents }: Omit<ConsentNotShowedDetail, "type">) {
    super({ type: "consentNotShowed", vendorsList, vendorConsents, purposeConsents });
  }
}
